import type { FaireProductEntity } from "../../entity_types/product";

export const p_6nt3g6dzvf: FaireProductEntity = {
  token: "p_6nt3g6dzvf",
  type: "product",
  name: "Baby Criss-Cross Beanie with Double Pom-Pom",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/5e94d7d66713159180cb45a8130832c4f5272e9c72825712ec509504d49f9689.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bdfd583e89f85cb2b1d828675a81d63694f75c6e32fe9fd2653f6e3e97502fd1.jpeg",
    "https://cdn.faire.com/fastly/687c623ee29278a28886292ba7f5f24b72ff6533025ced8d33d5bd48871fce6c.jpeg",
    "https://cdn.faire.com/fastly/35b6cd69842e7e553c47c8d86fdc2d4e584a5188c79833bf8e979ee44e4d432d.jpeg",
    "https://cdn.faire.com/fastly/f7588ba9ea6a70779b273baced248974f6cdc1b903807be7f53cc3e94dfb1d81.jpeg",
    "https://cdn.faire.com/fastly/6be0517fdd319a8379c43db459d97d01f278f1802953b28d0c8a376be0d20e86.jpeg",
    "https://cdn.faire.com/fastly/873e319d2291e47a2dd2bf7a9a698149224a598affb6f586657136249f8f9291.jpeg",
    "https://cdn.faire.com/fastly/4da8421f99a793e739a2b11c7d4c5bbe9f9d85d5ce957f4df97667eb67504657.jpeg",
    "https://cdn.faire.com/fastly/8279956885ba1094f8d2d9dfe13eccc1cc0c45032b34034d5d5c21791d654151.jpeg",
    "https://cdn.faire.com/fastly/3fa454e0bdc07a433662b6f4b0cff46b1c86a4d5c58f6097d82a82312e1bef49.jpeg",
    "https://cdn.faire.com/fastly/ce0ae41a933b6658e494c171db09787403b26ee8de7bebb3496b59054c4c3571.jpeg",
    "https://cdn.faire.com/fastly/a484635b51b25c095091a70a48047f9bf804ae3ef00bfc1056fa1d8107a77157.jpeg",
    "https://cdn.faire.com/fastly/9eeeca651c04bbfbfbf785e54a314079de785d71918ace80041feb85385aec8f.jpeg",
    "https://cdn.faire.com/fastly/03568973211257403e15820c5cf6eef02f5751ccb31ebf0db14e1ed108c9e274.jpeg",
    "https://cdn.faire.com/fastly/20b930e6e04db6f3d5f4d1613f4f2082987a8a5533b5f10f93e25fafcba1a1ba.jpeg",
    "https://cdn.faire.com/fastly/226abd5f34a397f7c7eb7b1abde7784a29ae3f3a7151affe72b03829c032e668.jpeg",
    "https://cdn.faire.com/fastly/c8d7c6122453116dfeedd41dce47ef93d84193698c9c6da9ba7d33c6aad447ca.jpeg",
    "https://cdn.faire.com/fastly/55ba1f6db5e787011236c049f6ff2afce10a733a33536a16430966730bf45743.jpeg",
  ],
  priceDollars: 11.7,
  description:
    'Baby Beanie Hat with Pom Pom\n\n- Faux Fur Pom-Pom Attached\n- Ribbed Cuff Beanie Hat\n- 47% Rayon, 31% PBT, 22% Nylon\n- Baby Hat ( For 0 to 9 months )\n\n**One Size Fits Most(Head Circumference: 14"-16")**',
  tags: [],
  msrpDollars: 35.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:05.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
